import LayoutStyles from '@Styles/layout.scss';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Drawer } from '@mui/material';
import React from 'react';
import Styles from './CloseableDrawer.scss';

interface ICloseableDrawerProps {
    children: React.ReactNode;
}

interface ICloseableDrawerState {
    isOpen: boolean;
}

export class CloseableDrawer extends React.Component<
    ICloseableDrawerProps,
    ICloseableDrawerState
> {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: props.isOpen ?? false,
        };
        this.closeDrawer = this.closeDrawer.bind(this);
    }

    closeDrawer() {
        this.setState({ isOpen: false });
    }

    render() {
        const btnXValue = this.state.isOpen
            ? `calc(${Styles.qcDrawerWidth} + 10px)`
            : '10px';
        const icon = this.state.isOpen ? (
            <ChevronLeftIcon />
        ) : (
            <ChevronRightIcon />
        );

        const toggleVisibility = () => {
            this.setState({
                isOpen: !this.state.isOpen,
            });
        };

        return (
            <>
                <Drawer
                    variant="temporary"
                    hideBackdrop
                    anchor="left"
                    open={this.state.isOpen}
                    sx={{
                        '.MuiDrawer-paper': {
                            height: `calc(100% - ${LayoutStyles.headerHeight})`,
                            top: LayoutStyles.headerHeight,
                            //'overflow-y': 'clip',
                            overflowY: 'hidden',
                        },
                    }}
                    disableEnforceFocus
                >
                    <div className={Styles.drawerInnerContainer}>
                        {this.props.children}
                    </div>
                </Drawer>
                <button
                    onClick={toggleVisibility}
                    style={{ left: btnXValue }}
                    className={Styles.toggleBtn}
                >
                    {icon}
                </button>
            </>
        );
    }
}
